// ══════════════════════════════════════════════════════════════════════════
//  ACCESO: leer el perfil de quien entra, con tiempo límite
//
//  Entrar (useAcceso), guardar la contraseña del enlace y abrir la app con la sesión
//  guardada (App.js) leen el perfil para decidir si la persona pasa. Las llamadas a Auth
//  ya tenían tiempo límite (supabaseClient.js, llamarAuth) y esta lectura no: con una
//  barra de señal, Auth respondía y el perfil se quedaba colgado minutos con «Verificando…»
//  y sin salida (2026-09-16). Aquí se corta con AbortController + setTimeout (no
//  AbortSignal.timeout: el bundle apunta a es2018) y la carrera garantiza el límite aunque
//  la petición ignore la señal.
//
//  Devuelve lo mismo que cargarPerfil (arreglo de filas o { error }). Sin respuesta a
//  tiempo: { error, __tiempoAgotado: true }, que decidirPerfil lee como servicio («El
//  servicio de acceso no responde»), igual que una llamada de Auth que se agota.
// ══════════════════════════════════════════════════════════════════════════
import { cargarPerfil } from '../shell/shell.data.js';

/** El mismo límite que las llamadas a /auth/v1 (AUTH_TIEMPO_MS de supabaseClient.js). */
export const PERFIL_TIEMPO_MS = 15000;

/**
 * @param {string} perfilId
 * @param {{tiempoMs?:number}} [opciones]
 * @returns {Promise<Object[]|{error:Object, __network?:boolean, __tiempoAgotado?:boolean}>}
 */
export async function leerPerfilConLimite(perfilId, { tiempoMs = PERFIL_TIEMPO_MS } = {}) {
  const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
  let reloj = null;
  const vencida = new Promise((resolver) => {
    reloj = setTimeout(() => {
      // Primero se resuelve la carrera y después se corta la petición: el corte llega como
      // error de red y no debe ganarle al tiempo agotado.
      resolver({ error: { message: 'Tiempo de espera agotado', code: '' }, __tiempoAgotado: true });
      try { if (ctrl) ctrl.abort(); } catch (e) { /* sin abort */ }
    }, tiempoMs);
  });
  try {
    const lectura = Promise.resolve(cargarPerfil(perfilId, '*', ctrl ? { signal: ctrl.signal } : undefined));
    return await Promise.race([lectura, vencida]);
  } catch (e) {
    return { error: { message: 'No se pudo leer el perfil', code: '' } };
  } finally {
    clearTimeout(reloj);
  }
}
